import React from "react";
import {
  Container,
  Paper,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TableContainer,
  Box,
  Typography
} from "@mui/material";
import { useDropzone } from "react-dropzone";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { toast } from "react-toastify";
import swal from "sweetalert";
import * as dataApi from "../../api/dataApi";

class IBNR extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      years: [],
      year: "",
      month: 1,
      type: 1,
      files: [],
      page: 0,
      rowsPerPage: 50,
      sortDirection: "desc",
      open: false,
      response: {},
    };
  }

  async componentDidMount() {
    try {
      const years = await dataApi.getYearsIBNR();
      if (years) {
        years.sort((a, b) => b - a);
        this.setState({ years });
      }
      const year = years[0];
      this.setState({ years, year });
      this.getData(year);
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  getData = async (year) => {
    const { type, month } = this.state;
    const data = await dataApi.getIBNRdata(type, year, month);
    this.setState({ data: data || [] });
  };

  handleChange = async (e) => {
    await this.setState({ [e.target.name]: e.target.value });
    this.getData(this.state.year);
  };

  handleFileChange = (acceptedFiles) => {
    this.setState({ files: acceptedFiles });
  };

  handleUpload = async () => {
    const { files } = this.state;
    if (files.length) {
      const response = await dataApi.uploadIBNRfile(files);
      if (response) {
        if (response.status === "Success") {
          swal({
            title: "Opplastingen er vellykket!",
            icon: "success",
          });
        } else if (response.status === "Fail") {
          this.setState({ open: true, response });
        }
      } else {
        swal({
          title: "Opplastingen er mislykket!",
          text: "Teknisk feil. Kontakt administrator.",
          icon: "error",
          dangerMode: true,
        });
      }
    } else {
      toast.error("Velg en fil..");
    }
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  };

  compareByDesc = (key) => (a, b) => (a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0);

  compareByAsc = (key) => (a, b) => (a[key] > b[key] ? -1 : a[key] < b[key] ? 1 : 0);

  sortBy = (key) => {
    const { data, sortDirection } = this.state;
    const sortedData = [...data].sort(
      sortDirection === "asc" ? this.compareByAsc(key) : this.compareByDesc(key)
    );
    this.setState({ data: sortedData, sortDirection: sortDirection === "asc" ? "desc" : "asc" });
  };

  render() {
    const { data, years, year, month, type, page, rowsPerPage, open, response } = this.state;
    const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

    const headerStyleDark = {
      backgroundColor: "#e6e6e6",
      fontWeight: "bold",
      fontSize: 16,
    };

    return (
      <Container maxWidth="lg">
        <main style={{ width: "100%", paddingTop: 80, margin: "auto" }}>
          <Paper style={{ width: "100%", padding: 20 }}>
            <Grid container spacing={6}>
              <Grid item lg={6}>
                <h2>IBNR data:</h2>
                <Grid item lg={12}>
                  <FormControl variant="standard" fullWidth>
                    <InputLabel>Skadetype</InputLabel>
                    <Select name="type" value={type || ""} onChange={this.handleChange}>
                      <MenuItem value={1}>Uforsikret</MenuItem>
                      <MenuItem value={2}>Ukjent</MenuItem>
                      <MenuItem value={3}>Yrkesskade</MenuItem>
                      <MenuItem value={4}>Grenseforsikring</MenuItem>
                      <MenuItem value={5}>Utland</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={12} style={{ paddingTop: 10 }}>
                  <FormControl variant="standard" fullWidth>
                    <InputLabel>År</InputLabel>
                    <Select name="year" value={year || ""} onChange={this.handleChange}>
                      {years.map((yr, index) => (
                        <MenuItem key={index} value={yr}>
                          {yr}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={12} style={{ paddingTop: 10 }}>
                  <FormControl variant="standard" fullWidth>
                    <InputLabel>Måned</InputLabel>
                    <Select name="month" value={month || ""} onChange={this.handleChange}>
                      {months.map((m) => (
                        <MenuItem key={m} value={m}>
                          {m}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Paper style={{ width: "100%", marginTop: 20 }}>
                  <TableContainer>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell style={headerStyleDark}>Skadeår</TableCell>
                          <TableCell align="right" style={headerStyleDark}>
                            Beløp
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.length > 0 ? (
                          data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
                            <TableRow key={index}>
                              <TableCell>{item.incidentYear}</TableCell>
                              <TableCell align="right">{item.amount.toLocaleString("de-DE")}</TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={2} align="center">
                              Ingen data tilgjengelig
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 50]}
                    component="div"
                    count={data.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                  />
                </Paper>
              </Grid>
              <Grid item lg={6}>
                <h2>Import av IBNR-data:</h2>
                <Dropzone onDrop={this.handleFileChange} />
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<CloudDownloadIcon />}
                  onClick={this.handleUpload}
                  style={{ marginTop: 20 }}
                >
                  Last opp
                </Button>
              </Grid>
            </Grid>
          </Paper>
          <Dialog open={open} onClose={this.handleClose} fullWidth>
            <DialogTitle>
              {`Totalt ${response.totalRowsOfData || 0} rader, ${response.successfulRows || 0
                } rader er importert`}
            </DialogTitle>
            <DialogContent>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={headerStyleDark}>Rad</TableCell>
                      <TableCell style={headerStyleDark}>Sak nr.</TableCell>
                      <TableCell style={headerStyleDark} align="center">
                        Detaljer
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {response.failedRows &&
                      response.failedRows.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell>{row.rowNr}</TableCell>
                          <TableCell>{row.comment}</TableCell>
                          {row.fieldErrors &&
                            row.fieldErrors.map((error, idx) => (
                              <TableRow key={idx}>
                                <TableCell>{error.fieldNr}</TableCell>
                                <TableCell>{error.fieldName}</TableCell>
                                <TableCell>{error.errorMessage}</TableCell>
                              </TableRow>
                            ))}
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Avbryt
              </Button>
            </DialogActions>
          </Dialog>
        </main>
      </Container>
    );
  }
}

function Dropzone({ onDrop }) {
  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({
    onDrop,
    accept: [".xls", ".xlsx", ".txt", ".csv"],
    maxFiles: 1,
  });

  return (
    <Box
      {...getRootProps()}
      sx={{
        border: "2px dashed #aaa",
        padding: 4,
        textAlign: "center",
        cursor: "pointer",
      }}
    >
      <input {...getInputProps()} />
      <Typography variant="body1">
        Dra og slipp en fil her eller klikk for å velge en fil
      </Typography>
      {acceptedFiles.length > 0 && (
        <Typography variant="subtitle1" sx={{ mt: 2 }}>
          Valgt fil: {acceptedFiles[0].name}
        </Typography>
      )}
    </Box>
  );
}

export default IBNR;
